import { Dispatch, SetStateAction, useEffect } from "react";

import { useTranslation } from "../../core/translation.core";
import { useSingleExcelDragUpload } from "../reuseables/dragUpload.hooks";

export default function ExcelFileDrop({ setExcelData }: { setExcelData: Dispatch<SetStateAction<any[] | null>> }) {
  const { register, dragState, excelData } = useSingleExcelDragUpload<any[]>();
  const { t, msg } = useTranslation();

  useEffect(() => {
    setExcelData(excelData);

    // eslint-disable-next-line
  }, [excelData]);

  let className =
    "w-full h-32 border-4 border-dotted rounded-md flex justify-center items-center text-slate-800 cursor-pointer " + //
    (dragState === "enter" ? "bg-green-400 " : "");

  return (
    <>
      <div className={className} {...register()}>
        {t(msg.form.dropYourFilesHere)}
      </div>
    </>
  );
}
